module.exports = __webpack_public_path__ + "img/book-open-page-variant.5a191410.svg";